// extracted by mini-css-extract-plugin
module.exports = {"body":"Home_body__2wYwK","containterCards":"Home_containterCards___mztE","containterCard":"Home_containterCard__1JOId"};